import axios from 'axios';
import config from '../../../config';

const baseUrl = config.baseUrl;
const Endpoint = '/api/getVisitaTecnicaById';

// Crear una instancia de Axios para configurar base URL y otras opciones
const api = axios.create({
    baseURL: config.baseUrl,
});


const getVisitaTecnicaById = async (id) => {
    try {
        const response = await api.get(`${baseUrl}${Endpoint}/${id}`);
        return {
            status: response.status,
            data: response.data.data,

        };
    } catch (error) {
        console.error('Error fetching visita técnica:', error);
        return {
            status: error.response ? error.response.status : 500,
            message: 'Error fetching visita técnica'
        };
    }
};

export default getVisitaTecnicaById;